(function () {
  function init(root) {
    var scroller = root.querySelector("[data-b2b-partners-scroll]");
    var dots = root.querySelectorAll("[data-b2b-partners-dot]");
    var slides = root.querySelectorAll("[data-b2b-partners-slide]");
    if (!scroller || !slides.length) return;

    function slideLeft(index) {
      var el = slides[index];
      if (!el) return 0;
      return el.offsetLeft;
    }

    function setActive(index) {
      dots.forEach(function (dot, i) {
        var on = i === index;
        dot.classList.toggle("is-active", on);
        dot.setAttribute("aria-selected", on ? "true" : "false");
      });
    }

    function activeIndexFromScroll() {
      var left = scroller.scrollLeft;
      var best = 0;
      var bestDist = Infinity;
      slides.forEach(function (sl, i) {
        var d = Math.abs(sl.offsetLeft - left);
        if (d < bestDist) {
          bestDist = d;
          best = i;
        }
      });
      return best;
    }

    function onScroll() {
      if (!dots.length) return;
      setActive(activeIndexFromScroll());
    }

    dots.forEach(function (dot, i) {
      dot.addEventListener("click", function () {
        scroller.scrollTo({ left: slideLeft(i), behavior: "smooth" });
      });
    });

    scroller.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener(
      "resize",
      function () {
        onScroll();
      },
      { passive: true }
    );
    onScroll();
  }

  document.querySelectorAll("[data-b2b-partners-section]").forEach(init);

  if (typeof Shopify !== "undefined" && Shopify.designMode) {
    document.addEventListener("shopify:section:load", function (ev) {
      var t = ev.target;
      if (!t) return;
      var root =
        t.matches && t.matches("[data-b2b-partners-section]")
          ? t
          : t.querySelector
            ? t.querySelector("[data-b2b-partners-section]")
            : null;
      if (root) init(root);
    });
  }
})();
